// Structured content — kept separate from presentation so it can move to a CMS later.

export const businessDetails = {
  name: "Freeman Jones Ltd",
  phoneDisplay: "0161 672 8990",
  phoneLink: "tel:01616728990",
  email: "contactus@freemanjones.co.uk",
  emailLink: "mailto:contactus@freemanjones.co.uk",
  customerAppUrl: "/try-our-app",
  digitalPostboxUrl: "https://postbox-fj.financialwellnessgroup.co.uk/",
  complaintsGatewayUrl: "https://www.gov.uk/complain-about-insolvency-practitioner",
  insolvencyServicePhone: "0300 678 0015",
  insolvencyServicePhoneLink: "tel:03006780015",
  companyNumber: "04348410",
  registeredOffice: "Blue Tower, MediaCityUK, Salford Quays, M50 2NT",
  privacyPolicyUrl: "/privacy-policy",
  moneyHelperUrl:
    "https://www.moneyhelper.org.uk/en/money-troubles/dealing-with-debt/debt-advice-locator",
  complaintsPolicyUrl: "/docs/ComplaintsProcedure-FJL.pdf",
  brochureUrl: "/docs/A10474_FWG_Financial_Fitness_Brochure.pdf",
};

export const images = {
  hero:
    "https://static.prod-images.emergentagent.com/jobs/1899d687-538f-4623-9b02-af7678f27e6a/images/f1dd3f1232064d3b291b9ed74edb7e4a2438b44d431c9aa20337f9777d942039.png",
  advisor:
    "https://static.prod-images.emergentagent.com/jobs/1899d687-538f-4623-9b02-af7678f27e6a/images/152badc63b1e801f18e06f36b32565b1df659731045ce6879b86e5637b0d72ee.png",
  appMockup: "/app-screen.png",
  appMockup2: "/app-screen-2.png",
  appMockup3: "/app-screen-3.png",
};

export const appFeatures = [
  { title: "Track your progress", body: "See how your arrangement is progressing at a glance, at any time." },
  { title: "Stay up to date", body: "Keep informed with the latest updates on your IVA and payments." },
  { title: "Message your team", body: "Get in touch with your support team securely from your phone." },
  { title: "Upload documents", body: "Send documents and information quickly and securely." },
  { title: "Feel at ease", body: "Manage everything in one calm, simple place — whenever it suits you." },
];

export const navItems = [
  { label: "Home", short: "Home", href: "#top" },
  { label: "About Us", short: "About", href: "#about" },
  { label: "Understanding Your IVA", short: "Your IVA", href: "#understanding-iva" },
  { label: "Customer Support", short: "Support", href: "#support-timeline" },
  { label: "Documents", short: "Documents", href: "#documents" },
  { label: "FAQs", short: "FAQs", href: "#faqs" },
  { label: "Contact Us", short: "Contact", href: "#contact" },
];

export const trustTiles = [
  { value: "Established", label: "and experienced", sub: "A trusted UK insolvency services business." },
  { value: "Licensed", label: "Insolvency Practitioners", sub: "Authorised by the IPA." },
  { value: "Throughout", label: "your arrangement", sub: "Support from start to completion." },
  { value: "Clear", label: "fair communication", sub: "We explain things simply and treat you fairly." },
  { value: "Secure", label: "online services", sub: "Manage your arrangement through the app and postbox." },
  { value: "Experienced", label: "specialist team", sub: "Dedicated to supervising Individual Voluntary Arrangements." },
];

export const ivaFeatures = [
  "Reduce your monthly payments to a level you can afford.",
  "Make one affordable monthly payment instead of juggling several creditors.",
  "Free up money for essentials such as your mortgage or rent, food and utilities.",
  "Interest and charges on the debts included are usually frozen once your IVA is approved.",
  "Have any included unsecured debt you can’t repay written off on successful completion.",
  "Get legal protection from action by the unsecured creditors included in your IVA.",
  "Work towards being free of your included unsecured debts over an agreed period.",
  "Your arrangement is proposed and supervised by a Licensed Insolvency Practitioner.",
];

export const ivaConsiderations = [
  "There’s no guarantee that your creditors will agree to an IVA.",
  "An IVA will have a serious impact on your credit rating, normally for at least six years.",
  "Your name will appear on a public insolvency register.",
  "Your day-to-day spending may be restricted while your IVA is running.",
  "You’ll need to keep up with your mortgage or rent, as these aren’t included in the IVA.",
  "An IVA usually lasts around five years, though in some cases it may run longer depending on the terms that apply to your arrangement.",
  "If you earn more during your IVA, a review of your circumstances will take place and you may need to increase your payments (any increased expenses will be taken into account).",
  "If you don’t keep to the terms of your IVA, it may fail and you could be made bankrupt.",
  "An IVA is a formal insolvency solution and isn’t suitable for everyone.",
];

// The Insolvency Practitioner's two roles across the life of an IVA.
export const ipRole = {
  intro:
    "Every IVA must be handled by a Licensed Insolvency Practitioner. At Freeman Jones we act in both key roles — first as your Nominee, and then as your Supervisor — so you have the same trusted team with you from your first proposal through to completion.",
  roles: [
    {
      title: "As your Nominee",
      body: "Before your IVA begins, we listen. We discuss your circumstances with you, help prepare your proposal and assess what you can realistically afford. It’s a detailed process, but our Insolvency Practitioners have the experience to get you off to a good start — putting your proposal to your creditors and managing the formal decision to seek their approval.",
    },
    {
      title: "As your Supervisor",
      body: "Once your IVA is up and running, you won’t be on your own. We administer the arrangement throughout its term — collecting your payments and passing them to your creditors, keeping your records up to date, carrying out reviews, and guiding your IVA all the way through to its formal completion.",
    },
  ],
};

export const supportSteps = [
  {
    step: "01",
    title: "Understanding your arrangement",
    body: "We help you understand the responsibilities, payments and conditions contained within your IVA proposal.",
  },
  {
    step: "02",
    title: "Managing your arrangement",
    body: "Our team administers your arrangement and maintains records of payments, documents and relevant changes.",
  },
  {
    step: "03",
    title: "Reviewing your circumstances",
    body: "You may be asked to provide updated financial information so that your arrangement can be reviewed in accordance with its terms.",
  },
  {
    step: "04",
    title: "Completing your IVA",
    body: "When all agreed responsibilities have been met, the arrangement can progress through the formal completion process.",
  },
  {
    step: "05",
    title: "Managing it on the go",
    body: "Track your progress, upload documents and message your team any time using the free Freeman Jones mobile app.",
  },
];

export const supportTopics = [
  "Change in financial circumstances",
  "Problems making a payment",
  "Annual review information",
  "Updating contact details",
  "Sending documents",
  "Questions about correspondence",
  "Complaints",
  "IVA completion documents",
];

export const documents = [
  {
    title: "Protocol Standard IVA Conditions — post April 2017",
    description:
      "Standard conditions applying to relevant Freeman Jones proposals submitted after 6 April 2017.",
    fileType: "PDF",
    url: "/docs/A9023-FJ-Standard-Conditions-2017-version.pdf",
  },
  {
    title: "Straightforward Consumer IVA Protocol — 2016 version",
    description:
      "Protocol documentation applying to relevant Freeman Jones proposals submitted after 6 April 2017.",
    fileType: "PDF",
    url: "/docs/IVA-Protocol-2016-2016-version.pdf",
  },
  {
    title: "Protocol Standard IVA Conditions — post July 2012",
    description:
      "Standard conditions applying to relevant Freeman Jones proposals submitted after 1 July 2012.",
    fileType: "PDF",
    url: "/docs/ProtocolStandardConditions2012-2012-version.pdf",
  },
  {
    title: "A Creditors’ Guide to Insolvency Practitioners’ Fees and a copy of Rule 5.23",
    description:
      "Information for creditors about Insolvency Practitioners’ fees and a copy of the applicable Rule 5.23.",
    fileType: "PDF",
    url: "/docs/Voluntary_arrangement_creditor_fee_guide_6_April_2017.pdf",
  },
];

export const faqs = [
  {
    q: "What is an IVA?",
    category: "About IVAs",
    a: "An IVA is a formal, legally binding agreement between you and your creditors to pay an agreed amount towards your debts, usually through regular monthly payments over an agreed period. It must be proposed and supervised by a Licensed Insolvency Practitioner, and once approved it is binding on the unsecured creditors included in it.",
  },
  {
    q: "Who qualifies for an IVA?",
    category: "About IVAs",
    a: "You may qualify if you’re unable to repay your unsecured debts (such as credit cards, personal loans and overdrafts) in a reasonable time, but can still afford a reasonable monthly payment towards them. Your IVA must be approved by creditors who account for at least 75% (by value) of your total unsecured debt. IVAs are available to residents of England, Wales and Northern Ireland — in Scotland, a Trust Deed may be the alternative. An IVA isn’t suitable for everyone.",
  },
  {
    q: "What debts can I include in an IVA?",
    category: "About IVAs",
    a: "An IVA can cover unsecured, non-priority debts such as credit and store cards, catalogues, unsecured loans, overdrafts and other credit agreements. Once your IVA is approved, all of your unsecured creditors are included — even any who didn’t vote, or who voted against it.",
  },
  {
    q: "What debts aren’t included in an IVA?",
    category: "About IVAs",
    a: "Priority debts are not included — for example your mortgage or rent, secured loans and student loans. Your IVA payments are based on what you can afford after your priority debts and essential living costs (food, utilities, transport and so on) are covered, so those essentials stay protected.",
  },
  {
    q: "How much does an IVA cost, and how are the fees paid?",
    category: "Costs & the IP role",
    a: "You only ever pay what you can realistically afford each month — there’s no fixed minimum, and your IVA can proceed if your creditors accept your proposal. An IVA always involves fees because it’s a formal, legally binding process, but these fees are covered within your agreed monthly payments, so you’ll know what you’ll pay before your IVA begins. To discuss what your payments could be, call us on 0161 672 8990.",
  },
  {
    q: "Can I set up an IVA on my own?",
    category: "Costs & the IP role",
    a: "No. As a formal insolvency solution, an IVA can only be set up and overseen by a Licensed Insolvency Practitioner. An IVA is different from a debt management plan, which you could arrange yourself or through a debt solutions provider.",
  },
  {
    q: "What does an Insolvency Practitioner do?",
    category: "Costs & the IP role",
    a: "Your Insolvency Practitioner prepares your IVA proposal — the document setting out your circumstances and how the IVA would work — and puts it to your creditors, who must approve it by at least 75% (by value) of the debt involved. Once approved, your IP administers your IVA throughout its term, reviews it regularly, distributes payments to your creditors and helps you deal with any issues that arise.",
  },
  {
    q: "Who are the FJL licenced Insolvency Practitioners?",
    category: "Costs & the IP role",
    a: "Catherine McNeill & Michael Bellingham are licenced Insolvency Practitioners regulated by The Insolvency Practitioners Association.",
  },
  {
    q: "Will an IVA affect my credit rating?",
    category: "Living with an IVA",
    a: "Yes. An IVA will adversely affect your credit rating and normally stays on your credit file for six years from the date it starts. Details of your IVA are also recorded on the public Individual Insolvency Register.",
  },
  {
    q: "Will I be able to get credit after my IVA finishes?",
    category: "Living with an IVA",
    a: "Yes, though it may be harder at first and any credit offered could come with less favourable terms, such as higher interest. Your IVA stays on your credit record for six years from the date it starts, so if you complete a five-year IVA it will remain on your file for around a year afterwards.",
  },
  {
    q: "Will my car be at risk if I enter an IVA?",
    a: "Usually you can keep your car, as it’s often essential for work and family life. If it’s a particularly expensive vehicle, you might be asked to sell it and buy a cheaper one so more can go towards your IVA.",
  },
  {
    q: "What is the IVA Register?",
    category: "Living with an IVA",
    a: "The Individual Insolvency Register is a publicly available online register listing people in an IVA, bankruptcy or Debt Relief Order. For an IVA it shows the approval date, your name, address, date of birth and gender, and the name and address of your IVA supervisor.",
  },
  {
    q: "Will my employer know about my IVA?",
    category: "Living with an IVA",
    a: "You don’t have to tell your employer about your IVA unless your contract requires it, and your IP would only contact your employer if they were one of your creditors. Your details would appear on the public Individual Insolvency Register, but employers don’t usually search it without reason. Some roles, such as in financial services, may involve regular credit checks.",
  },
  {
    q: "What’s the difference between an IVA and bankruptcy?",
    category: "About IVAs",
    a: "Both are forms of insolvency that can give legal protection from creditors and write off unsecured debt. An IVA typically lasts around five to six years and usually lets you keep your home, whereas bankruptcy often lasts around a year but can require your assets, including your home, to be sold, and can restrict certain jobs. Which is right depends on your circumstances, so it’s important to get expert advice first.",
  },
  {
    q: "What happens if I can’t make my IVA payments?",
    category: "Living with an IVA",
    a: "Missing a payment doesn’t mean your IVA fails immediately, but it’s important not to ignore it — contact us as soon as possible. Depending on your situation we may be able to agree a short break in payments, or draw up an IVA Variation to adjust the terms. If your circumstances have changed for the long term, we’ll help you look at the best way forward.",
  },
  {
    q: "What happens if I earn more during my IVA?",
    category: "Living with an IVA",
    a: "Your IVA payments are based on what you can afford, so your income is reviewed each year. If your take-home pay increases, you can usually keep a set portion of the increase and pay a proportion of the rest into your IVA — the exact figures depend on the terms that apply to your arrangement. Extra one-off money, such as a bonus or a windfall like an inheritance, normally needs to be paid in as well. If your income goes down, your payments can be reviewed too, so it’s always best to keep us updated.",
  },
  {
    q: "What should I do if my circumstances change?",
    category: "Account & support",
    a: "Contact Freeman Jones as soon as possible if your income, expenditure, employment, household or other relevant circumstances change. The team will explain what information is required and how the terms of your arrangement may apply.",
  },
  {
    q: "Who supervises my IVA?",
    category: "Account & support",
    a: "An IVA is supervised by a Licensed Insolvency Practitioner. Freeman Jones will provide the appropriate contact and regulatory details for the Insolvency Practitioner supervising your arrangement.",
  },
  {
    q: "How do I download the Freeman Jones mobile app?",
    category: "Account & support",
    a: "The free Freeman Jones app is available to download from the Apple App Store (for iPhone and iPad) and Google Play (for Android devices). Just search for “Freeman Jones” in your device’s app store, or use the “Get the Customer App” button on this website. Once installed, sign in with your Freeman Jones customer details to manage your arrangement on the go.",
  },
  {
    q: "How can I access my Freeman Jones account?",
    category: "Account & support",
    a: "Use the Customer App button on this website to access the online customer service.",
    action: "app",
  },
  {
    q: "How can I access my digital correspondence?",
    category: "Account & support",
    a: "Use the Freeman Jones Digital Postbox to securely access correspondence made available through that service.",
    action: "postbox",
  },
  {
    q: "How do I make a complaint?",
    category: "Account & support",
    a: "Freeman Jones has a complaints process for customers who are dissatisfied with the service they have received. Please visit the Complaints section or contact the team for a copy of the complaints procedure.",
    action: "complaints",
  },
];

export const reasonOptions = [
  "Question about my arrangement",
  "Change in financial circumstances",
  "Problem making a payment",
  "Annual review",
  "Update my contact details",
  "Sending documents",
  "Making a complaint",
  "Something else",
];

// Editorial marquee ethos words
export const marqueeItems = [
  "Reassuring",
  "Experienced",
  "Professional",
  "Non-judgmental",
  "Clear and straightforward",
];

// Trustpilot — aggregate figures verified from the public Trustpilot page.
export const trustpilot = {
  score: "4.8",
  scoreOutOf: 5,
  label: "Excellent",
  total: 677,
  url: "https://uk.trustpilot.com/review/freemanjones.co.uk",
  logoUrl: "https://uk.trustpilot.com/review/freemanjones.co.uk",
  reviews: [
    {
      name: "Karen W.",
      rating: 5,
      date: "April 2025",
      text: "From start to finish I was treated with respect and kindness. I was guided through my journey by professional, friendly individuals. My IVA was made easy by the kindness that I felt from the lovely people that helped me. Thank you.",
    },
    {
      name: "Juju J.",
      rating: 5,
      date: "September 2026",
      text: "I can’t believe how easy it was to sort out my finances — this company really helped me a lot. I can now sleep and start to enjoy life knowing everything is taken care of. My IVA is in place and I just want to say thank you Freeman Jones.",
    },
    {
      name: "James",
      rating: 5,
      date: "September 2026",
      text: "Very helpful and understanding customer services — my experience has been stress free throughout. Would recommend to anyone who is struggling with big debts.",
    },
    {
      name: "Trustpilot customer",
      rating: 5,
      date: "September 2026",
      text: "The service provided was excellent and they made the process stress free. I highly recommend Freeman Jones.",
    },
    {
      name: "Jacki",
      rating: 5,
      date: "September 2026",
      text: "I felt I was on a sinking ship with my debt situation, but Freeman Jones are helping me with my problems — so polite and understanding. When talking on the phone they put you at ease. I would definitely recommend.",
    },
    {
      name: "Emma S.",
      rating: 5,
      date: "September 2026",
      text: "Really listened to all my worries and went through all the options in detail. I can’t thank Thomas enough for all the support and guidance — it was an absolute pleasure and he put my mind at rest. Would highly recommend this service.",
    },
    {
      name: "Clare L.",
      rating: 5,
      date: "August 2026",
      text: "All the agents were easy to speak to, friendly and explained everything in simple terms. They were empathetic and realistic with the expected outcome. It’s not an easy thing to get started with, but they made it so easy. Thank you!",
    },
    {
      name: "Jason L.",
      rating: 5,
      date: "August 2026",
      text: "I called out for help and Freeman Jones answered. The staff listened, explained a lot of options and which one would best help my family. They explained the ins and outs of how IVAs work — the positives and the negatives. Now my IVA has been approved I can finally start living again. Thank you.",
    },
    {
      name: "Darren P.",
      rating: 5,
      date: "August 2026",
      text: "Brilliant service. Very supportive and friendly, and the communication is brilliant. Thank you for your help — I would recommend.",
    },
    {
      name: "Kaine D.",
      rating: 5,
      date: "August 2026",
      text: "Fantastic staff who were very friendly, empathetic and understanding. They gave great advice the whole way through set up, and you truly did not feel judged or belittled for whatever situation you were in. Thank you!",
    },
    {
      name: "Lisa",
      rating: 5,
      date: "August 2026",
      text: "Freeman Jones made a very stressful situation much better. We went through all possible options before settling on an IVA, and I was kept well informed at every point. The staff are exceptional — friendly, understanding and they don’t judge. I can now get my life back on track.",
    },
    {
      name: "Emma",
      rating: 5,
      date: "August 2026",
      text: "I honestly wish I’d just taken control sooner. The team have shown empathy and no judgement in supporting me and I’m thankful for that. I’m grateful there’s a business that is just there to help.",
    },
    {
      name: "Ruth",
      rating: 5,
      date: "June 2026",
      text: "Very accommodating and understanding, easy to get in touch with, and they take into account changing circumstances. Always happy to help.",
    },
  ],
};

